import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface SenderData {
    customer_manager_idx: number;
    manager_name: string;
    manager_mobile: string;
}

interface GetSenderResponse {
    data: SenderData[];
}

export const useGetOrderManager = (customerIdx: string): UseQueryResult<GetSenderResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetSenderResponse, Error>({
        queryKey: ["getCommonSender", customerIdx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_manager.replace(":customer_idx", customerIdx)}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
        enabled: !!customerIdx,
    });
};
